import React, { useContext, useState, useRef, useEffect } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { AuthContext } from './App';
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import {
    UserIcon,
    ChevronDownIcon,
    BookmarkIcon,
    LogoutIcon,
    TrashIcon,
  } from '@heroicons/react/solid'

function Header() {
    const { auth, setAuth } = useContext(AuthContext);
    const [isOpen, setIsOpen] = useState(false); // Toggle state for the mobile menu
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false); 
    const navigate = useNavigate();
    const dropdownRef = useRef(null);  // Ref for the dropdown
    const buttonRef = useRef(null);  // Ref for the button

    const signOut = () => {
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('user');
        localStorage.removeItem('email');
        setAuth({ isLoggedIn: false, user: null });
        navigate('/login');
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
                buttonRef.current && !buttonRef.current.contains(event.target)) {
                setIsProfileMenuOpen(false);
            }
        }
        
        if (isProfileMenuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isProfileMenuOpen]);

    return (
        <nav className="border-b-2 border-black px-4 lg:px-6 py-5 font-sans">
            <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-lg">
                <Link to="/" className="flex items-center pr-4 border-black border-r">
                    <span className="self-center text-2xl font-semibold dark:text-white">FinalOffers</span>
                </Link>
                {/* <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
                    <span className="sr-only">Open main menu</span>
                    <svg className={`${isOpen ? 'hidden' : 'block'} w-6 h-6`} viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M3 5h14a1 1 0 010 2H3a1 1 0 110-2zm0 5h14a1 1 0 010 2H3a1 1 0 110-2zm0 5h14a1 1 0 010 2H3a1 1 0 110-2z" clipRule="evenodd" />
                    </svg>
                    <svg className={`${isOpen ? 'block' : 'hidden'} w-6 h-6`} viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </button> */}
                {/* <div className={`${isOpen ? 'flex' : 'hidden'} lg:hidden flex-col items-start w-full mt-4 z-50`}>
                    <NavLink  to="/browse" className={({ isActive }) => `text-gray-700 dark:text-white border-b-2 ${isActive ? 'border-black' : ''}`}>Browse</NavLink>
                    <NavLink  to="/submit" className={({ isActive }) => `text-gray-700 dark:text-white border-b-2 ${isActive ? 'border-black' : ''}`}>Submit</NavLink >
                    <a href="#" className="py-2 text-gray-700 dark:text-white w-full text-left">Contact Us</a>
                    {auth.isLoggedIn ? (
                        <>
                            <NavLink to="/profile" className={({ isActive }) => `text-gray-700 dark:text-white border-b-2 ${isActive ? 'border-black' : ''}`}>Profile</NavLink>
                            <button onClick={signOut} className="py-2 text-gray-700 dark:text-white w-full text-left">Sign Out</button>
                        </>
                    ) : (
                        <>
                            <NavLink to="/login" className={({ isActive }) => `hidden text-gray-700 dark:text-white border-b-2 ${isActive ? 'border-black' : ''}`}>Log in</NavLink>
                            <NavLink to="/signup" className={({ isActive }) => `hidden text-gray-700 dark:text-white border-b-2 ${isActive ? 'border-black' : ''}`}>Sign Up</NavLink>
                        </>
                    )}
                </div> */}
                <div className="hidden lg:flex lg:items-center lg:w-auto lg:space-x-8 justify-center flex-grow">
                
                    <NavLink to="/browse" className={({ isActive }) => ` border-b-2 ${isActive ? 'border-black' : 'border-none'}`}>Browse</NavLink>
                    <NavLink to="/submit" className={({ isActive }) => ` border-b-2 ${isActive ? 'border-black' : 'border-none'}`}>Submit</NavLink>
                    <a href="#" className="text-gray-700 dark:text-white">Contact Us</a>
                </div>
                {auth.isLoggedIn ? (
                    <>
                        <div className="relative">
                            <button ref={buttonRef} onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)} className="hidden lg:flex lg:items-center lg:bg-white lg:rounded lg:py-1.5 lg:px-3 lg:text-xs lg:text-black lg:border lg:border-black lg:ring-2 lg:ring-custom-ring">
                                
                                Menu
                             <ChevronDownIcon className="ml-2 size-3" />
                            </button>
                            {/* <div ref={dropdownRef} className={`${isProfileMenuOpen ? 'scale-100 opacity-100' : 'hidden'} absolute mt-2 w-36 right-0 rounded border bg-white transition-transform duration-200 ease-out shadow-solid z-50`}> */}
                            <div ref={dropdownRef} className={`${
                                isProfileMenuOpen ? 'opacity-100 translate-y-0 visible' : '-translate-y-2.5 invisible'
                            } absolute mt-2 w-36 right-0 rounded border bg-white transition-all ease-out duration-200 shadow-solid z-50 lg:block hidden`}
                                style={{ transitionProperty: 'opacity, transform' }}>
   
                                <Link to="/profile" className="flex px-4 py-2 text-sm hover:rounded hover:bg-black hover:text-white">
                                    <UserIcon className="mr-2 mt size-5" />
                                    Profile
                                </Link>
                                <Link to="/profile" className="flex px-4 py-2 text-sm hover:rounded hover:bg-black hover:text-white">
                                    <BookmarkIcon className="mr-2 size-5" />
                                    Bookmarks
                                </Link>
                                <div className="my-1 h-px bg-black mx-2" />
                                <button onClick={signOut} className=" w-full text-left px-4 py-2 text-sm bg-white hover:rounded hover:bg-black hover:text-white inline-flex items-center">
                                    <LogoutIcon className="mr-2 h-5 w-5" /> Sign Out
                                </button>

                            </div>
                        </div>
                    </>

                    
                ) : (
                    <>
                        <Link to="/login" className=" hover:bg-gray-50 font-medium rounded text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800">Log in</Link>
                        <Link to="/signup" className="text-white bg-black font-medium rounded text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2">Sign Up</Link>
                    </>
                )}
            </div>
        </nav>
    );
}

export default Header;

                //     <Menu>
                //     <MenuButton className="hidden lg:flex lg:items-center lg:bg-white lg:rounded lg:py-1.5 lg:px-3 lg:text-xs lg:text-black lg:border lg:border-black lg:ring-2 lg:ring-custom-ring">
                //         {/* <FontAwesomeIcon icon="fa-regular fa-user" /> */}
                //         Menu
                //         <ChevronDownIcon className="ml-2 size-3" />
                //     </MenuButton>
                //     <Transition
                //       enter="transition ease-out duration-75"
                //       enterFrom="opacity-0 scale-95"
                //       enterTo="opacity-100 scale-100"
                //       leave="transition ease-in duration-100"
                //       leaveFrom="opacity-100 scale-100"
                //       leaveTo="opacity-0 scale-95"
                //     >
                //       <MenuItems
                //         anchor="bottom end"
                //         className="w-24 origin-top-left rounded border mt-1 text-xs border-black bg-white focus:outline-none shadow-solid"
                //       >
                //         <MenuItem>
                //             <Link to="/profile" className="group flex border-2 border-transparent hover:bg-black hover:text-white items-center ">
                //                 <UserIcon className="size-4 " />
                //                 Profile
                //             </Link>
                //           {/* <button className="group flex w-full items-center gap-2 rounded-lg py-1.5 px-3 data-[focus]:bg-white/10">
                //            Edit 
                //          </button> */} 
                //         </MenuItem>
                //         <MenuItem>
                //             <Link to="/profile" className="group flex mx-1 px-1 my-1 border-2 border-transparent hover:border-2 hover:border-black items-center rounded">Bookmarks</Link>
                //           {/* <button className="group flex w-full items-center gap-2 rounded-lg py-1.5 px-3 data-[focus]:bg-white/10">
                //             Duplicate
                //           </button> */}
                //         </MenuItem>
                //         <div className="my-1 h-px bg-black mx-2" />
                //         <MenuItem>
                //           <button onClick={signOut} className="group flex ml-1 mr-1 px-1 my-1 border-2 border-transparent hover:border-2 hover:border-black items-center rounded">
                //             Sign Out
                //           </button>
                //         </MenuItem>
                //       </MenuItems>
                //     </Transition>
                //   </Menu>

{/* <div className="hidden lg:flex lg:items-center lg:space-x-8">
    {auth.isLoggedIn ? (
        <>
            <div className="relative">
                <button onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)} className="flex items-center rounded-full focus:outline">
                    <svg className="w-6 h-6 fill-current text-gray-800 dark:text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path d="M10 12a5 5 0 100-10 5 5 0 000 10zm0 2c-5.33 0-8 2.686-8 4a1 1 0 001 1h14a1 1 0 001-1c0-1.314-2.67-4-8-4z" />
                    </svg>
                </button>
                <div className={`${isProfileMenuOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0'} absolute mt-2 w-24 rounded-md bg-white border-2 border-gray-300 transition-transform transition-opacity duration-200 ease-out shadow-solid`}>
                    <Link to="/profile" className="block px-4 py-2 text-sm hover:border-black">Profile</Link>
                    <button onClick={signOut} className="block w-full text-left px-4 py-2 text-sm hover:border-black">Sign Out</button>
                </div>
            </div>
        </>
    ) : (
        <>
            <Link to="/login" className="text-gray-800 dark:text-white hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800">Log in</Link>
            <Link to="/signup" className="text-white bg-black font-medium rounded text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2">Sign Up</Link>
        </>
    )}
</div> */}

// import React, { useContext, useState } from 'react';
// import { Link, useNavigate  } from 'react-router-dom';
// import { AuthContext } from './App';

// function Header() {
//     const { auth, setAuth } = useContext(AuthContext);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [isOpen, setIsOpen] = useState(false); // Toggle state for the mobile menu
//     const navigate = useNavigate();

//     const handleSearchChange = (event) => {
//         setSearchTerm(event.target.value);
//     };

//     const handleSearchSubmit = (event) => {
//         event.preventDefault();
//         console.log('Searching for:', searchTerm);
//         // Implement the search functionality here
//     };

//     const signOut = () => {
//         localStorage.removeItem('isLoggedIn');
//         localStorage.removeItem('user');
//         setAuth({ isLoggedIn: false, user: null });
//         navigate('/login');
//     };

//     return (
//         <nav className="border-b-2 border-black px-4 lg:px-6 py-5 font-sans">
//             <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-lg">
//                 <Link to="/" className="flex items-center">
//                     <span className="self-center text-2xl font-semibold dark:text-white">FinalOffers</span>
//                 </Link>
//                 <div className="flex items-center lg:order-2">
//                     {auth.isLoggedIn ? (
//                         <>
//                             <Link to="/profile" className="text-gray-800 dark:text-white hover:bg-gray-50 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800">Profile</Link>
//                             <button onClick={signOut} className="text-red-600 hover:text-red-800 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2">Sign Out</button>
//                         </>
//                         // <Link to="/profile" className="text-gray-800 dark:text-white hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800">Profile</Link>
//                     ) : (
//                         <>
//                             <Link to="/login" className="text-gray-800 dark:text-white hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800">Log in</Link>
//                             <Link to="/signup" className="text-white bg-black font-medium rounded text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 ">Sign Up</Link>
//                         </>
//                     )}
//                     <button data-collapse-toggle="mobile-menu-2" type="button" class="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="mobile-menu-2" aria-expanded="false">
//                         <span class="sr-only">Open main menu</span>
//                         <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
//                         <svg class="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
//                     </button>
//                 </div>
//                 <div className="hidden justify-between items-center w-full lg:flex lg:w-auto lg:order-1"  id="mobile-menu-2">
//                     <ul className="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0">
//                         {/* <li>
//                             <Link to="/" className="block py-2 pr-4 pl-3 text-white rounded bg-primary-700 lg:bg-transparent lg:text-primary-700 lg:p-0 dark:text-white">Home</Link>
//                         </li> */}
//                         <li className="pr-5">
//                             <Link to="/browse" className="block focus:border-b-2 focus:border-black">Browse</Link>
//                         </li>
//                         <li className="pl-5 pr-5">
//                             <Link to="/submit" className="block focus:border-b-2 focus:border-black">Submit</Link>
//                         </li>
//                         <li className="pl-5">
//                             <a href="#" className="block focus:border-b-2 focus:border-black">Contact Us</a>
//                         </li>
//                     </ul>
//                 </div>
//             </div>
//         </nav>
//     );
// }

// export default Header;

// // import React, { useState } from 'react';
// // import { Link } from 'react-router-dom';

// // function Header() {
// //     const [searchTerm, setSearchTerm] = useState('');

// //     const handleSearchChange = (event) => {
// //         setSearchTerm(event.target.value);
// //     };

// //     const handleSearchSubmit = (event) => {
// //         event.preventDefault();
// //         console.log('Searching for:', searchTerm);
// //         // Implement the search functionality here
// //     };

// //     return (
// //         // <header>
// //             <nav class="bg-white border-gray-200 px-4 lg:px-6 py-2.5 dark:bg-gray-800">
// //                 <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
// //                     <a href="https://flowbite.com" class="flex items-center">
// //                         {/* <img src="https://flowbite.com/docs/images/logo.svg" class="mr-3 h-6 sm:h-9" alt="Flowbite Logo" /> */}
// //                         <span class="self-center text-xl font-semibold whitespace-nowrap dark:text-white">FinalOffers</span>
// //                     </a>
// //                     <div class="flex items-center lg:order-2">
// //                         <a href="#" class="text-gray-800 dark:text-white hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800">Log in</a>
// //                         <a href="#" class="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800">Sign Up</a>
// //                         <button data-collapse-toggle="mobile-menu-2" type="button" class="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="mobile-menu-2" aria-expanded="false">
// //                             <span class="sr-only">Open main menu</span>
// //                             <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
// //                             <svg class="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
// //                         </button>
// //                     </div>
// //                     <div class="hidden justify-between items-center w-full lg:flex lg:w-auto lg:order-1" id="mobile-menu-2">
// //                         <ul class="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0">
// //                             <li>
// //                                 <Link to="/" className="block py-2 pr-4 pl-3 text-white rounded bg-primary-700 lg:bg-transparent lg:text-primary-700 lg:p-0 dark:text-white">Home</Link>
// //                             </li>
// //                             <li>
// //                                 <Link to="/submit" className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Submit</Link>
// //                                 {/* <a href="#" class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Submit</a> */}
// //                             </li>
// //                             <li>
// //                                 <Link to="/browse" className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Browse</Link>
// //                             </li>
// //                             <li>
// //                                 <a href="#" class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700">Contact</a>
// //                             </li>
// //                         </ul>
// //                     </div>
// //                 </div>
// //             </nav>
// //         // </header>
// //         // <nav>
// //         //     <div className="container mx-auto px-6 py-3 flex items-center justify-between">
// //         //         <div className="flex items-center">
// //         //             <div className="font-roboto-bold text-2xl font-bold tracking-tighter mr-10">
// //         //                 finaloffer.
// //         //             </div>
// //         //             <div className="font-roboto text-lg mt-2">
// //         //                 <a href="/submit" className="header-link mr-4">Submit.</a>
// //         //                 <a href="/titles" className="header-link mr-4">Titles.</a>
// //         //                 <a href="/companies" className="header-link">Companies.</a>
// //         //             </div>
// //         //         </div>
// //         //         <form onSubmit={handleSearchSubmit} className="flex items-center">
// //         //             <input
// //         //                 type="search"
// //         //                 value={searchTerm}
// //         //                 onChange={handleSearchChange}
// //         //                 placeholder="Search anything..."
// //         //                 className="font-garamond text-white bg-transparent border-b-2 border-white-500 text-xs font-bold py-1 leading-tight focus:outline-none focus:border-white"
// //         //             />
// //         //         </form>
// //         //     </div>
// //         // </nav>
// //     );
// // }

// // export default Header;